module.exports = __webpack_public_path__ + "media/fr_ca_s3_Louise.84f33d9d.oga";